export const formatDuration = (duration: number): string => {
  const totalSeconds = Math.round(duration || 0);
  const mins = Math.floor(totalSeconds / 60);
  const secs = totalSeconds % 60;

  return `${mins}:${secs.toString().padStart(2, "0")}`;
};
